import util from '../util'

let base = window.$servicePath

export default {


  /**
   * 当前登录单位的下属和下属单位树
   * @param unitId 为null 则是当前用户登录单位
   */
  listCurUnit(unitId) {
    return util.ajax(`${base}/api/common/listCurUnit`,unitId);
  },

  /**
   * 当前登录单位的所有部门
   */
  listCurDepartment() {
    return util.ajax(`${base}/api/org/getLoginUserUnitDepartments`);
  },


  /**
   * 通过部门ID,获取部门下所有部门
   * @param parentId
   * @return List<MAP>
   *     [{id:'ID',
   *       name:'名称',
   *       flag:'标识 1 单位  2 部门  3子部门',
   *       hasChild:'下级个数'}]
   */
  listDepartmentByPrentId(parentId) {
    return util.ajax(`${base}/api/common/listDepartmentByPrentId`,parentId);
  },


}



// WEBPACK FOOTER //
// ./src/common/api/common.js